import "assets/scss/material-dashboard-pro-react.scss?v=1.5.0";
import "./App.css";
import login from "../src/views/Login/Login.js";
import Dashboard from "../src/views/Dashboard/Dashboard";
import EditProfile from "./views/Profile/EditProfile";
import Unit from "../src/views/Master/Unit";
import LocationMaster from "../src/views/Master/LocationMaster";
import HSCode from "../src/views/Master/HSCode";
import PortMaster from "../src/views/Master/PortMaster";
import CategoryMaster from "views/Master/CategoryMaster";
import SubCategoryMaster from "views/Master/SubCategoryMaster";
import HSNCode from "views/Master/HSNCodeMaster";
import DetailsVariantMaster from "./views/Master/DetailsVariantMaster";
import Network from "./views/Network/Network.js";
import ProcessMaster from "views/Master/ProcessMaster";
import Request from "views/Request/Request";
import BrandMaster from "views/Master/BrandMaster";
import CompanyInitials from "views/Configuration/CompanyInitials";
import Group from "@material-ui/icons/Group";
import MapIcon from "@material-ui/icons/Map";
import ChatIcon from "@material-ui/icons/Chat";
import "assets/equator-scss/style.scss";
import ReasonMaster from "views/Master/ReasonMaster";
import Verification from "../src/views/Verification/verification.js";
import PhoneVerification from "../src/views/Verification/verificationPhone.js";
import CountryMaster from "../src/views/Master/CountryMaster.js";
import GeneralConfiguration from "views/GeneralConfiguration/GeneralConfiguration.js";
import Configuration from "views/Configuration/Configuration";
import UnitConfiguration from "views/Configuration/UnitConfiguration";
import ProductMaster from "views/Master/ProductMaster";
import AddDetailsVariantMaster from "views/Master/AddDetailsVariantMaster";
import LoyaltyProgram from "views/Loyalty/LoyaltyReward";
import LoyaltyRedeemtion from "views/Loyalty/LoyaltyRedeemtion";
import Warehouse from "views/Master/WareHouse/Warehouse";
import AddWareHouse from "views/Master/WareHouse/AddWareHouse";
import ViewWarehouse from "views/Master/WareHouse/ViewWarehouse";
import Inward from "views/Inventory/Inward";
import AddInward from "views/Inventory/AddInward";
import AddNetwork from "views/Network/AddMyNetwork";
import Outward from "views/Inventory/Outward";
import AddOutward from "views/Inventory/AddOutward";
import PerformaInvoice from "views/Inventory/PerformaInvoice";
import AddPerformaInvoice from "views/Inventory/AddPerformaInvoice";
import AuditOrder from "views/Audit and Order/AuditOrder";
import OrderListing from "views/Audit and Order/OrderListing";
import AddPOS from "views/POS/AddPOS";
import CompanyMaster from "views/Master/CompanyMaster/CompanyMaster";
import ImageConfiguration from "views/Configuration/ImageConfiguration";
import AddManufacturing from "views/Inventory/AddManufacturing";
import Manufacturing from "views/Inventory/Manufacturing";
import AlertConfig from "views/Configuration/AlertConfig";
import BarcodeConfig from "views/Configuration/BarcodeConfig";
import POSBillConfiguration from "views/Configuration/POSBillConfiguration";
import BranchMaster from "views/Master/BranchMaster";
import BranchConfiguration from "views/Configuration/BranchConfiguration";
import TemplateMaster from "views/Master/TemplateMaster";
import POSListing from "views/POS/POSListing";
import PriceDifferenceReport from "views/Reports/PriceDifferenceReport";
import RegularityIrregularityReport from "views/Reports/RegularityIrregularityReport";
import SalesReport from "views/Reports/SalesReport";
import SalesOrder from "views/Inventory/SalesOrder";
import AddSalesOrder from "views/Inventory/AddSalesOrder";
import PaymentModeMaster from "views/Master/PaymentModeMaster";
import ServiceCharges from "views/Master/ServiceCharges";
import ScheduleReport from "views/Reports/ScheduleReport";
import AddScheduleReport from "views/Reports/AddScheduleReport";

var dashRoutes = [
  {
    path: "/login",
    component: login,
    invisible: false,
  },
  {
    path: "/verification",
    component: Verification,
    layout: "/auth",
    invisible: false,
  },
  {
    path: "/phoneverification",
    component: PhoneVerification,
    layout: "/auth",
    invisible: false,
  },
  {
    path: "/editprofile",
    name: "Edit Profile",
    ServiceName: "Profile",
    restricted: true,
    icon: Group,
    component: EditProfile,
    layout: "/admin",
    invisible: false,
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    icon: "pi pi-th-large",
    component: Dashboard,
    restricted: true,
    ServiceName: "Dashboard",
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/unit",
    name: "Unit",
    ServiceName: "Unit",
    restricted: true,
    icon: "pi pi-chart-pie",
    component: Unit,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/location-master",
    name: "Location Master",
    ServiceName: "Location Master",
    restricted: true,
    icon: "pi pi-map-marker",
    component: LocationMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/hscode",
    name: "ServiceCode",
    ServiceName: "Service Code",
    restricted: true,
    icon: MapIcon,
    component: HSCode,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/hsn-code-master",
    name: "HSN Code Master",
    ServiceName: "HSN Code Master",
    restricted: true,
    icon: "pi pi-share-alt",
    component: HSNCode,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/port-master",
    name: "Port Master",
    ServiceName: "Port",
    restricted: true,
    icon: "pi pi-filter-fill",
    component: PortMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/category-master",
    name: "Category Master",
    ServiceName: "Category Master",
    restricted: true,
    icon: "pi pi-sun",
    component: CategoryMaster,
    ServiceNae: "Category Master",
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/sub-category-master",
    name: "SubCategory Master",
    ServiceName: "Sub Category Master",
    restricted: true,
    icon: "pi pi-clone",
    component: SubCategoryMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/brand-master",
    name: "Brand Master",
    ServiceName: "Brand Master",
    restricted: true,
    icon: "pi pi-bolt",
    component: BrandMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/product-master",
    name: "Product Master",
    ServiceName: "Product Master",
    restricted: true,
    icon: "pi pi-box",
    component: ProductMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/details-variant-master",
    name: "Details And Variant Master",
    ServiceName: "Details And Variant Master",
    restricted: true,
    icon: "pi pi-file-edit",
    component: DetailsVariantMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-details-variant-master",
    name: "Add Details And Variant Master",
    ServiceName: "Add Details And Variant Master",
    restricted: true,
    icon: "pi pi-ticket",
    component: AddDetailsVariantMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/process",
    name: "Process Master",
    ServiceName: "Process Master",
    restricted: true,
    icon: "pi pi-map",
    component: ProcessMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/network",
    name: "Network",
    ServiceName: "Network",
    restricted: true,
    icon: "pi pi-sort-amount-up",
    component: Network,
    ServiceName: "Network",
    layout: "/admin",
    invisible: false,
  },
  {
    path: "/add-network",
    name: "Add Network",
    ServiceName: "Add Network",
    restricted: true,
    icon: Group,
    component: AddNetwork,
    ServiceName: "Add Network",
    layout: "/admin",
    invisible: false,
  },
  {
    path: "/request",
    name: "Request",
    icon: ChatIcon,
    component: Request,
    restricted: true,
    ServiceName: "Request",
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/company-initials",
    name: "Company Initials",
    ServiceName: "Company Initials",
    icon: "pi pi-chart-line",
    component: CompanyInitials,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/configuration",
    name: "Configuration",
    ServiceName: "Configuration",
    icon: "pi pi-cog",
    component: Configuration,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/general-configuration",
    name: "General Configuration",
    ServiceName: "General Configuration",
    icon: ChatIcon,
    component: GeneralConfiguration,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/alert-configuration",
    name: "Alert Configuration",
    ServiceName: "Alert Configuration",
    restricted: true,
    icon: "pi pi-arrows-alt",
    component: AlertConfig,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/barcode-configuration",
    name: "Barcode Configuration",
    ServiceName: "Barcode Configuration",
    restricted: true,
    icon: "pi pi-arrows-alt",
    component: BarcodeConfig,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/master",
    name: "Master",
    ServiceName: "Master",
    icon: "pi pi-sitemap",
    component: null,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/reason-master",
    name: "Reason Master",
    ServiceName: "Reason Master",
    icon: "pi pi-flag",
    component: ReasonMaster,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/CountryMaster",
    name: "Country Master",
    ServiceName: "Country Master",
    restricted: true,
    icon: "pi pi-eraser",
    component: CountryMaster,
    layout: "/admin",
    invisible: false,
  },
  {
    path: "/unit-configuration",
    name: "Unit Configuration",
    ServiceName: "Unit Configuration",
    restricted: true,
    icon: "pi pi-arrows-alt",
    component: UnitConfiguration,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/loyalty",
    name: "Loyalty",
    ServiceName: "Loyalty",
    restricted: true,
    icon: "pi pi-map",
    component: null,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/loyalty-reward",
    name: "Loyalty Reward",
    ServiceName: "Loyalty Reward",
    restricted: true,
    icon: "pi pi-sun",
    component: LoyaltyProgram,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/loyalty-redeem",
    name: "Loyalty Redeem",
    ServiceName: "Loyalty Redeem",
    restricted: true,
    icon: "pi pi-tags",
    component: LoyaltyRedeemtion,
    layout: "/admin",
    invisible: true,
  },

  {
    path: "/warehouse-master",
    name: "Warehouse",
    ServiceName: "Warehouse Master",
    restricted: true,
    icon: "icon-container-lift",
    component: Warehouse,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-warehouse-master",
    name: "Add Ware House",
    ServiceName: "Add Ware House",
    icon: MapIcon,
    restricted: true,
    component: AddWareHouse,
    layout: "/admin",
    invisible: false,
  },
  {
    path: "/view-warehouse-master",
    name: "View Ware House",
    ServiceName: "View Ware House",
    icon: MapIcon,
    component: ViewWarehouse,
    restricted: true,
    layout: "/admin",
    invisible: false,
  },
  {
    path: "/inventory",
    name: "Inventory",
    ServiceName: "Inventory",
    restricted: true,
    icon: "pi pi-box",
    component: null,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/inward",
    name: "Inward",
    ServiceName: "Inward",
    restricted: true,
    icon: "pi pi-arrow-up-right",
    component: Inward,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-inward",
    name: "Add Inward",
    ServiceName: "Add Inward",
    restricted: true,
    icon: "pi pi-ticket",
    component: AddInward,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/outward",
    name: "Outward",
    ServiceName: "Outward",
    restricted: true,
    icon: "pi pi-arrow-up-left",
    component: Outward,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-outward",
    name: "Add Outward",
    ServiceName: "Add Outward",
    restricted: true,
    icon: "pi pi-ticket",
    component: AddOutward,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/performa-invoice",
    name: "Performa Invoice",
    ServiceName: "Performa Invoice",
    restricted: true,
    icon: "pi pi-arrow-up-left",
    component: PerformaInvoice,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-performa-invoice",
    name: "Add Performa Invoice",
    ServiceName: "Add Performa Invoice",
    restricted: true,
    icon: "pi pi-ticket",
    component: AddPerformaInvoice,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/sales-order",
    name: "Sales Order",
    ServiceName: "Sales Order",
    restricted: true,
    icon: "pi pi-arrow-up-left",
    component: SalesOrder,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-sales-order",
    name: "Add Sales Order",
    ServiceName: "Add Sales Order",
    restricted: true,
    icon: "pi pi-ticket",
    component: AddSalesOrder,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/branch-master",
    name: "Branch Master",
    ServiceName: "Branch Master",
    icon: "pi pi-book",
    component: BranchMaster,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/audit-order",
    name: "Audit & Order",
    ServiceName: "Audit & Order",
    icon: "pi pi-book",
    component: AuditOrder,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/order-logs",
    name: "Order Logs",
    ServiceName: "Order Logs",
    icon: Group,
    component: OrderListing,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/add-pos",
    name: "add-POS",
    ServiceName: "Add POS",
    icon: "pi pi-shopping-cart",
    component: AddPOS,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/pos",
    name: "POS",
    ServiceName: "POS",
    icon: "pi pi-shopping-cart",
    component: POSListing,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/company-master",
    name: "Company Master",
    ServiceName: "Company Master",
    icon: "pi pi-clone",
    component: CompanyMaster,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/image-configuration",
    name: "Image Configuration",
    ServiceName: "Image Configuration",
    icon: "pi pi-images",
    component: ImageConfiguration,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/pos-bill-configuration",
    name: "POS Bill Configuration",
    ServiceName: "POS Bill Configuration",
    icon: "pi pi-images",
    component: POSBillConfiguration,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/manufacturing",
    name: "Manufacturing",
    ServiceName: "Inward",
    restricted: true,
    icon: "pi pi-arrow-up-right",
    component: Manufacturing,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/add-manufacturing",
    name: "Add Manufacturing",
    ServiceName: "Add Manufacturing",
    restricted: true,
    icon: "pi pi-ticket",
    component: AddManufacturing,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/branch-configuration",
    name: "Branch Configuration",
    ServiceName: "Branch Configuration",
    restricted: true,
    icon: "pi pi-ticket",
    component: BranchConfiguration,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/template-master",
    name: "Template Master",
    ServiceName: "Template Master",
    restricted: true,
    icon: "pi pi-ticket",
    component: TemplateMaster,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/price-difference-report",
    name: "Sales Report",
    ServiceName: "Sales Report",
    restricted: true,
    icon: "pi pi-arrows-alt",
    component: PriceDifferenceReport,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/regularity-irregularity-report",
    name: "Regularity Irregularity Report",
    ServiceName: "Regularity Irregularity Report",
    restricted: true,
    icon: "pi pi-arrows-alt",
    component: RegularityIrregularityReport,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/sales-report",
    name: "Price Difference Report",
    ServiceName: "Price Difference Report",
    restricted: true,
    icon: "pi pi-arrows-alt",
    component: SalesReport,
    layout: "/admin",
    invisible: true,
  },
  {
    path: "/payment-mode-master",
    name: "Payment Mode Master",
    ServiceName: "Payment Mode Master",
    icon: "pi pi-book",
    component: PaymentModeMaster,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/service-charges",
    name: "Service Charges",
    ServiceName: "Service Charges",
    icon: "pi pi-book",
    component: ServiceCharges,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/schedule-report",
    name: "Schedule Report",
    ServiceName: "Schedule Report",
    icon: "pi pi-book",
    component: ScheduleReport,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
  {
    path: "/add-schedule-report",
    name: "Add Schedule Report",
    ServiceName: "Add Schedule Report",
    icon: "pi pi-book",
    component: AddScheduleReport,
    layout: "/admin",
    restricted: true,
    invisible: true,
  },
];

export default dashRoutes;
